import React from 'react';
import { Target, Zap, TrendingUp, Users } from 'lucide-react';
export const WhyGigi = () => {
  return <div className="py-24 bg-white" data-id="element-1506">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1507">
        <div className="text-center mb-16" data-id="element-1508">
          <h2 className="text-4xl font-bold text-gray-900 mb-6" data-id="element-1509">
            Why Choose Human-Guided AI
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed" data-id="element-1510">
            Pure automation misses the nuance. Pure manual work doesn't scale.
            We combine the best of both worlds.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16" data-id="element-1511">
          <FeatureCard icon={<Users className="w-8 h-8" data-id="element-1513" />} title="Expert Oversight" description="Every campaign is designed and monitored by Irina, ensuring quality and strategic alignment" data-id="element-1512" />
          <FeatureCard icon={<Zap className="w-8 h-8" data-id="element-1515" />} title="AI-Powered Scale" description="Advanced AI handles research, personalization, and automation at scale" data-id="element-1514" />
          <FeatureCard icon={<Target className="w-8 h-8" data-id="element-1517" />} title="Proven Results" description="20-27% reply rates vs. industry average of 4-5%—backed by real data" data-id="element-1516" />
          <FeatureCard icon={<TrendingUp className="w-8 h-8" data-id="element-1519" />} title="Continuous Optimization" description="Weekly support sessions and ongoing campaign refinement based on performance" data-id="element-1518" />
        </div>
        <div className="bg-gradient-to-r from-[#6366f1]/5 to-[#d5ff00]/5 rounded-2xl p-12 border border-[#6366f1]/10" data-id="element-1520">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 text-center" data-id="element-1521">
            <StatCard value="20-27%" label="Reply Rate" subtext="(vs 4-5% industry avg)" data-id="element-1522" />
            <StatCard value="3x" label="Meeting Bookings" subtext="(proven results)" data-id="element-1523" />
            <StatCard value="17+" label="Years Experience" subtext="(guiding every campaign)" data-id="element-1524" />
          </div>
        </div>
      </div>
    </div>;
};
const FeatureCard = ({
  icon,
  title,
  description
}: {
  icon: React.ReactNode;
  title: string;
  description: string;
}) => <div className="flex flex-col items-center text-center p-8 bg-gray-50 rounded-2xl transition-all duration-300 hover:shadow-lg hover:bg-white border border-transparent hover:border-gray-100" data-id="element-1525">
    <div className="w-16 h-16 bg-[#d5ff00]/20 rounded-2xl flex items-center justify-center mb-6 text-[#6366f1]" data-id="element-1526">
      {icon}
    </div>
    <h3 className="text-lg font-semibold mb-3 text-gray-900" data-id="element-1527">{title}</h3>
    <p className="text-gray-600 leading-relaxed" data-id="element-1528">{description}</p>
  </div>;
const StatCard = ({
  value,
  label,
  subtext
}: {
  value: string;
  label: string;
  subtext: string;
}) => <div data-id="element-1529">
    <div className="text-5xl font-bold text-[#6366f1] mb-3" data-id="element-1530">{value}</div>
    <div className="text-base font-semibold text-gray-900 mb-1" data-id="element-1531">{label}</div>
    <div className="text-sm text-gray-500" data-id="element-1532">{subtext}</div>
  </div>;